export default "__VITE_ASSET__CJCxaOc2__"